/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bold_Tame_Finch_PushInputs */

const en_bold_tame_finch_push = /** @type {(inputs: Bold_Tame_Finch_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

const de_bold_tame_finch_push = /** @type {(inputs: Bold_Tame_Finch_PushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendet`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Bold_Tame_Finch_PushInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bold_tame_finch_push = /** @type {((inputs?: Bold_Tame_Finch_PushInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bold_Tame_Finch_PushInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bold_tame_finch_push(inputs)
	return de_bold_tame_finch_push(inputs)
});